(function () {
  'use strict';

  var FAQ_DEFAULT = [
    { q: 'What is included in a custom cleaning package?', a: 'Packages can include machines, chemicals, accessories, pads, brushes, hoses, carts, safety signs, PPE, and replacement parts depending on your facility and budget.' },
    { q: 'Can I customize a ready-made package?', a: 'Yes. Packages are a starting point — our team can adjust machines, accessories, and chemistry before you order.' },
    { q: 'Do you offer financing?', a: 'Financing may be available on qualifying commercial equipment. Contact us or visit our financing page for current options.' },
    { q: 'How does freight and delivery work?', a: 'We review lift-gate needs and delivery access for large machines. Eligible items qualify for free shipping on orders $99+.' },
    { q: 'How long does a custom quote take?', a: 'Most custom package quotes are returned within one business day after we receive your facility details.' },
    { q: 'Are you an authorized dealer?', a: 'Yes — we are an authorized dealer for 150+ commercial cleaning equipment brands with OEM parts and warranty support.' },
  ];

  function esc(v) {
    return String(v || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function heroAssetUrl(sampleUrl, assetName) {
    if (!sampleUrl || !assetName) return '';
    var base = sampleUrl.indexOf('//') === 0 ? 'https:' + sampleUrl : sampleUrl;
    if (base.indexOf('package-hero-') !== -1) {
      return base.replace(/package-hero-[^/?#]+/, assetName);
    }
    return base.replace('package-hero-default.jpg', assetName);
  }

  function heroCandidates(pageData, handle, id) {
    var list = [];
    if (pageData && pageData.hero_image_asset) list.push(pageData.hero_image_asset);
    if (pageData && pageData.hero_image_fallback) list.push(pageData.hero_image_fallback);
    var indexed = heroIndexAsset(handle, id);
    if (indexed) list.push(indexed);
    if (handle) list.push('package-hero-' + handle + '.jpg');
    list.push('package-hero-default.jpg');
    return list.filter(function (item, index) { return list.indexOf(item) === index; });
  }

  function heroIndexAsset(handle, id) {
    var idx = window.TCB_PACKAGE_HERO_INDEX;
    if (!idx) return '';
    if (handle && idx.by_handle && idx.by_handle[handle]) return idx.by_handle[handle];
    if (id && idx.by_id && idx.by_id[id]) return idx.by_id[id];
    return '';
  }

  function packageImageAlt(title) {
    return String(title || 'Commercial cleaning equipment package').trim() + ' — commercial cleaning equipment package photo';
  }

  function fetchProductJson(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (res) {
      if (!res.ok) throw new Error('missing product: ' + handle);
      return res.json();
    });
  }

  function primaryBundleHandle(presets, packageId) {
    var bundle = presets && presets.package_bundles && presets.package_bundles[packageId];
    return bundle && bundle.length ? bundle[0] : '';
  }

  function showImage(img, placeholder, url, alt) {
    if (!img || !url) return false;
    img.src = url;
    img.alt = alt || '';
    img.hidden = false;
    if (placeholder) placeholder.hidden = true;
    return true;
  }

  function showPlaceholder(img, placeholder) {
    if (img) img.hidden = true;
    if (placeholder) placeholder.hidden = false;
  }

  function applyProductImageFallback(img, placeholder, presets, packageId, alt, onFail) {
    var handle = primaryBundleHandle(presets, packageId);
    if (!handle) {
      if (onFail) onFail();
      else showPlaceholder(img, placeholder);
      return;
    }
    fetchProductJson(handle).then(function (product) {
      if (product.featured_image) {
        showImage(img, placeholder, product.featured_image, alt);
      } else if (onFail) {
        onFail();
      } else {
        showPlaceholder(img, placeholder);
      }
    }).catch(function () {
      if (onFail) onFail();
      else showPlaceholder(img, placeholder);
    });
  }

  function hydratePackageImage(root, pkg, master, presets, sampleUrl) {
    var card = root.querySelector('[data-package-page-handle="' + pkg.page_handle + '"]');
    if (!card) return;
    var img = card.querySelector('[data-tcb-facility-card-img]');
    var placeholder = card.querySelector('[data-tcb-facility-card-placeholder]');
    if (!img || !sampleUrl) return;

    var masterPage = master && master.pages_by_handle ? master.pages_by_handle[pkg.page_handle] : null;
    var alt = packageImageAlt(pkg.title);
    loadHeroImage(sampleUrl, heroCandidates(masterPage, pkg.page_handle, pkg.id), function (url) {
      showImage(img, placeholder, url, alt);
    }, function () {
      applyProductImageFallback(img, placeholder, presets, pkg.id, alt);
    });
  }

  function hydratePackageCardImages(root, packages, master, presets) {
    var sampleUrl = root.getAttribute('data-hero-asset-sample');
    if (!sampleUrl) return;
    packages.forEach(function (pkg) {
      hydratePackageImage(root, pkg, master, presets, sampleUrl);
    });
  }

  function renderCardMedia(title) {
    return (
      '<div class="tcb-facility-card__media">' +
        '<img class="tcb-facility-card__img" alt="' + esc(packageImageAlt(title)) + '" loading="lazy" decoding="async" width="640" height="360" hidden data-tcb-facility-card-img>' +
        '<span class="tcb-packages-hero__placeholder tcb-facility-card__placeholder" data-tcb-facility-card-placeholder aria-hidden="true"></span>' +
      '</div>'
    );
  }

  function renderFeaturedMedia(title) {
    return (
      '<div class="tcb-facility-featured__media">' +
        '<img class="tcb-facility-featured__img" alt="' + esc(packageImageAlt(title)) + '" loading="lazy" decoding="async" width="640" height="420" hidden data-tcb-facility-featured-img>' +
        '<span class="tcb-packages-hero__placeholder" data-tcb-facility-featured-placeholder aria-hidden="true"></span>' +
      '</div>'
    );
  }

  function hydrateFeaturedImage(root, pkg, master, presets) {
    if (!pkg) return;
    var sampleUrl = root.getAttribute('data-hero-asset-sample');
    var img = root.querySelector('[data-tcb-facility-featured-img]');
    var placeholder = root.querySelector('[data-tcb-facility-featured-placeholder]');
    if (!img || !sampleUrl) return;

    var masterPage = master && master.pages_by_handle ? master.pages_by_handle[pkg.page_handle] : null;
    var alt = packageImageAlt(pkg.title);
    loadHeroImage(sampleUrl, heroCandidates(masterPage, pkg.page_handle, pkg.id), function (url) {
      showImage(img, placeholder, url, alt);
    }, function () {
      applyProductImageFallback(img, placeholder, presets, pkg.id, alt);
    });
  }

  function applyFinalCtaImage(root, pageData, presets, facility) {
    var sampleUrl = root.getAttribute('data-hero-asset-sample');
    var handle = root.getAttribute('data-page-handle');
    var img = root.querySelector('[data-tcb-facility-final-img]');
    var placeholder = root.querySelector('[data-tcb-facility-final-placeholder]');
    if (!img || !sampleUrl) return;

    var alt = packageImageAlt((pageData && (pageData.hero_heading || pageData.page_title)) || root.querySelector('[data-tcb-facility-final-heading]')?.textContent);
    loadHeroImage(sampleUrl, heroCandidates(pageData, handle, pageData && pageData.id), function (url) {
      showImage(img, placeholder, url, alt);
    }, function () {
      var recId = facility && facility.recommended_id;
      applyProductImageFallback(img, placeholder, presets, recId, alt);
    });
  }

  function loadHeroImage(sampleUrl, candidates, onSuccess, onFail) {
    if (!candidates.length) {
      if (onFail) onFail();
      return;
    }
    var asset = candidates[0];
    var url = heroAssetUrl(sampleUrl, asset);
    if (!url) return loadHeroImage(sampleUrl, candidates.slice(1), onSuccess, onFail);
    var probe = new Image();
    probe.onload = function () { onSuccess(url, asset); };
    probe.onerror = function () { loadHeroImage(sampleUrl, candidates.slice(1), onSuccess, onFail); };
    probe.src = url;
  }

  function applyHeroImage(root, pageData, presets, facility) {
    var sampleUrl = root.getAttribute('data-hero-asset-sample');
    var handle = root.getAttribute('data-page-handle');
    var img = root.querySelector('[data-tcb-facility-hero-img]');
    var placeholder = root.querySelector('[data-tcb-facility-hero-placeholder]');
    if (!img || !sampleUrl) return;

    var alt = (pageData && (pageData.hero_heading || pageData.page_title)) || root.querySelector('h1')?.textContent || 'Facility cleaning package';
    loadHeroImage(sampleUrl, heroCandidates(pageData, handle, pageData && pageData.id), function (url) {
      img.src = url;
      img.alt = alt;
      img.hidden = false;
      if (placeholder) placeholder.hidden = true;
    }, function () {
      var recId = facility && facility.recommended_id;
      applyProductImageFallback(img, placeholder, presets, recId, alt);
    });
  }

  function badgeClass(badge) {
    var value = String(badge || '').toLowerCase();
    if (/best seller|most popular|recommended|popular/.test(value)) return ' tcb-facility-card__badge--green';
    if (/complete|full facility/.test(value)) return ' tcb-facility-card__badge--navy';
    if (/gear up|starter/.test(value)) return ' tcb-facility-card__badge--orange';
    return '';
  }

  function injectFaqSchema(root, faqs) {
    if (!window.TcbFaqSchema || !faqs || !faqs.length) return;
    var faqHost = root.querySelector('[data-tcb-facility-faq]');
    if (!faqHost) return;
    window.TcbFaqSchema.inject(faqHost, faqs, root.getAttribute('data-page-url') || window.location.href);
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-tcb-facility-sticky]');
    if (!bar) return;
    var hero = root.querySelector('.tcb-facility-hero');
    if (!hero) return;
    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '-1px 0px 0px 0px' });
    observer.observe(hero);
  }

  function painIconFile(title) {
    if (window.TcbPainChallenges && window.TcbPainChallenges.iconFileForTitle) {
      return window.TcbPainChallenges.iconFileForTitle(title);
    }
    var t = String(title || '').toLowerCase();
    if (/hallway|traffic|scuff/.test(t)) return 'tcb-menu-icon-walk-behind-scrubber.png';
    if (/restroom|odor|sanitation/.test(t)) return 'tcb-menu-icon-toilet-cleaner.png';
    if (/cafeteria|grease|spill/.test(t)) return 'tcb-menu-icon-industrial-spray.png';
    if (/gym|rubber/.test(t)) return 'tcb-menu-icon-scrub-brush.png';
    if (/classroom|touchpoint|dust/.test(t)) return 'tcb-menu-icon-hand-sanitizer.png';
    if (/event|after-event|assembly|sport/.test(t)) return 'tcb-menu-icon-school.png';
    return 'tcb-menu-icon-recommendation.png';
  }

  function renderPainInline(root, facility) {
    var grid = root.querySelector('[data-tcb-facility-pain]');
    if (!grid) return false;
    var painPoints = (facility.pain_points || []).map(function (p) {
      return { title: p.title, text: p.text || p.body || '' };
    }).filter(function (p) { return p.title; });
    if (!painPoints.length) return false;
    var sampleUrl = root.getAttribute('data-hero-asset-sample') || '';
    var assetBase = sampleUrl.lastIndexOf('/') >= 0 ? sampleUrl.slice(0, sampleUrl.lastIndexOf('/') + 1) : '';
    grid.innerHTML = painPoints.map(function (point) {
      var iconUrl = assetBase + painIconFile(point.title);
      return (
        '<li class="tcb-pain-challenges__card">' +
          '<span class="tcb-pain-challenges__icon" aria-hidden="true">' +
            '<img src="' + esc(iconUrl) + '" alt="" width="40" height="40" loading="lazy" decoding="async">' +
          '</span>' +
          '<strong>' + esc(point.title) + '</strong>' +
          '<span>' + esc(point.text) + '</span>' +
        '</li>'
      );
    }).join('');
    return true;
  }

  function renderPain(root, facility) {
    if (window.TcbPainChallenges) {
      window.TcbPainChallenges.render({
        zone: null,
        grid: root.querySelector('[data-tcb-facility-pain]'),
        headingEl: root.querySelector('[data-tcb-facility-pain-heading]'),
        painPoints: facility.pain_points,
        heading: null,
        assetSample: root.getAttribute('data-hero-asset-sample'),
      });
      return;
    }
    renderPainInline(root, facility);
  }

  function landingPackages(facility, packages) {
    var handles = facility.landing_package_handles;
    if (!handles || !handles.length) return packages;
    return handles.map(function (handle) {
      return packages.find(function (pkg) { return pkg.page_handle === handle; });
    }).filter(Boolean);
  }

  function renderGrid(root, packages, highlightTier, master, presets) {
    var grid = root.querySelector('[data-tcb-facility-grid]');
    if (!grid) return;
    var items = packages.slice().sort(function (a, b) { return (a.menu_order || 99) - (b.menu_order || 99); });
    if (highlightTier) {
      items.sort(function (a, b) {
        var am = a.tier === highlightTier ? -1 : 0;
        var bm = b.tier === highlightTier ? -1 : 0;
        return am - bm || (a.menu_order - b.menu_order);
      });
    }
    grid.innerHTML = items.map(function (pkg) {
      var badge = pkg.badge ? '<span class="tcb-facility-card__badge' + badgeClass(pkg.badge) + '">' + esc(pkg.badge) + '</span>' : '';
      return (
        '<article class="tcb-facility-card' + (highlightTier && pkg.tier === highlightTier ? ' is-highlight' : '') + '" data-tier="' + esc(pkg.tier) + '" data-package-page-handle="' + esc(pkg.page_handle) + '">' +
          renderCardMedia(pkg.title) +
          badge +
          '<h3>' + esc(pkg.title) + '</h3>' +
          '<p><strong>Best for:</strong> ' + esc(pkg.best_for) + '</p>' +
          '<ul class="tcb-facility-card__meta">' +
            '<li>✓ ' + esc(pkg.facility_size) + '</li>' +
            '<li>✓ ' + esc(pkg.main_machine) + '</li>' +
            '<li>✓ ' + esc(pkg.supplies_preview) + '</li>' +
          '</ul>' +
          '<p class="tcb-facility-card__price">' + esc(pkg.price_display) + '</p>' +
          '<div class="tcb-facility-card__actions">' +
            '<a class="tcb-page-btn tcb-page-btn--primary tcb-page-btn--navy" href="/pages/' + esc(pkg.page_handle) + '">View Package</a>' +
            '<a class="tcb-page-btn tcb-page-btn--secondary" href="#tcb-facility-compare">Compare</a>' +
          '</div>' +
        '</article>'
      );
    }).join('');
    hydratePackageCardImages(root, items, master, presets);
  }

  function renderFeatured(root, facility, packages, master, presets) {
    var host = root.querySelector('[data-tcb-facility-featured]');
    if (!host) return;
    var pkg = packages.find(function (p) { return p.id === facility.recommended_id; }) || packages.find(function (p) { return p.featured; }) || packages[7] || packages[0];
    if (!pkg) { host.innerHTML = ''; return; }
    host.innerHTML =
      '<div class="tcb-wrap tcb-facility-featured__grid">' +
        renderFeaturedMedia(pkg.title) +
        '<div class="tcb-facility-featured__copy">' +
          '<span class="tcb-facility-featured__badge' + (pkg.badge ? badgeClass(pkg.badge) : '') + '">' + esc(pkg.badge || 'Most Popular') + '</span>' +
          '<h2>' + esc(pkg.title) + '</h2>' +
          '<p>' + esc(pkg.best_for) + '</p>' +
          '<ul class="tcb-facility-featured__includes">' +
            '<li>✓ ' + esc(pkg.main_machine) + '</li>' +
            '<li>✓ ' + esc(pkg.supplies_preview) + '</li>' +
            '<li>✓ ' + esc(pkg.parts_included) + '</li>' +
          '</ul>' +
          '<p class="tcb-facility-featured__price">' + esc(pkg.price_display) + '</p>' +
          '<div class="tcb-facility-featured__actions">' +
            '<a class="tcb-page-btn tcb-page-btn--primary tcb-page-btn--navy" href="/pages/' + esc(pkg.page_handle) + '">View Full Package</a>' +
            '<a class="tcb-page-btn tcb-page-btn--secondary" href="' + esc(root.getAttribute('data-quote-url') || '/pages/contact?topic=equipment-package#tcb-contact-form') + '">Request Quote</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    hydrateFeaturedImage(root, pkg, master, presets);
  }

  function compareShortName(title) {
    return String(title || '').replace(/ Package$/, '').trim();
  }

  function compareCellValue(pkg, key) {
    var val = String(pkg[key] || '').trim();
    if (!val) return '—';
    if (key === 'best_for') {
      var first = val.split(/[.!?\n]/).map(function (part) { return part.trim(); }).filter(Boolean)[0] || val;
      if (first.length > 88) return first.slice(0, 85) + '…';
      return first;
    }
    if (key === 'floor_types' && val.length > 72) {
      return val.slice(0, 69) + '…';
    }
    return val;
  }

  function compareRowsFor(items) {
    var defs = [
      { key: 'best_for', label: 'Best For' },
      { key: 'facility_size', label: 'Facility Size' },
      { key: 'floor_types', label: 'Floor Type' },
      { key: 'main_machine', label: 'Main Machine' },
      { key: 'supplies_preview', label: 'Supplies' },
      { key: 'parts_included', label: 'Parts' },
      { key: 'budget_level', label: 'Budget Level' },
      { key: 'price_display', label: 'Starting Price' },
    ];
    return defs.filter(function (row) {
      var vals = items.map(function (p) { return String(p[row.key] || '').trim(); }).filter(Boolean);
      if (!vals.length) return false;
      if (row.key === 'budget_level') return vals.length > 0;
      if (row.key === 'floor_types') return new Set(vals).size > 1;
      return true;
    });
  }

  function renderCompare(root, packages) {
    var host = root.querySelector('[data-tcb-facility-compare-table]');
    if (!host) return;
    var items = packages.slice().sort(function (a, b) { return (a.menu_order || 99) - (b.menu_order || 99); });
    if (!items.length) {
      host.innerHTML = '';
      return;
    }
    var rows = compareRowsFor(items);
    var colCount = items.length + 1;
    host.innerHTML =
      '<table class="tcb-packages-tiers__table tcb-facility-compare__table" style="--tcb-compare-cols:' + colCount + '">' +
        '<thead><tr>' +
          '<th scope="col" class="tcb-facility-compare__feature-col">Feature</th>' +
          items.map(function (p) {
            var size = p.facility_size
              ? '<span class="tcb-packages-tiers__sub">' + esc(p.facility_size) + '</span>'
              : '';
            return '<th scope="col">' + esc(compareShortName(p.title)) + size + '</th>';
          }).join('') +
        '</tr></thead>' +
        '<tbody>' +
          rows.map(function (row) {
            return '<tr><th scope="row">' + esc(row.label) + '</th>' +
              items.map(function (p) {
                return '<td>' + esc(compareCellValue(p, row.key)) + '</td>';
              }).join('') +
            '</tr>';
          }).join('') +
          '<tr class="tcb-packages-tiers__cta-row"><td></td>' +
            items.map(function (p) {
              return '<td><a class="tcb-page-btn tcb-page-btn--primary tcb-page-btn--compact" href="/pages/' + esc(p.page_handle) + '">View Package</a></td>';
            }).join('') +
          '</tr>' +
        '</tbody></table>';
  }

  function renderZones(root, facility, pageHandle, sampleUrl) {
    var shell = root.querySelector('[data-tcb-facility-zones-shell]');
    if (!shell || !facility.zones) return;
    var beforeItems = ['Unreliable equipment', 'Mismatched chemicals', 'No spare parts on hand', 'Slow daily cleaning', 'No clear system'];
    var afterItems = ['Everything you need in one package', 'Matched machines and chemistry', 'Maintenance parts included', 'Faster daily cleaning', 'Easier staff training'];
    var zoneImageUrl = sampleUrl ? heroAssetUrl(sampleUrl, 'package-zone-' + (pageHandle || 'default') + '.jpg') : '';
    var tabs = facility.zones.map(function (z, i) {
      return '<button type="button" class="tcb-packages-tabs__tab' + (i === 0 ? ' is-active' : '') + '" data-tcb-zone="' + esc(z.id) + '" role="tab">' + esc(z.label) + '</button>';
    }).join('');
    var panels = facility.zones.map(function (z, i) {
      return (
        '<div class="tcb-packages-tabs__panel tcb-facility-zone-panel' + (i === 0 ? ' is-active' : '') + '" data-tcb-zone-panel="' + esc(z.id) + '"' + (i === 0 ? '' : ' hidden') + ' role="tabpanel">' +
          '<div class="tcb-facility-zone-panel__grid">' +
            '<div class="tcb-facility-zone-panel__copy">' +
              '<div class="tcb-facility-before-after__grid tcb-facility-before-after__grid--compact">' +
                '<article class="tcb-facility-before-after__card tcb-facility-before-after__card--before"><h3>Before</h3><ul>' +
                  beforeItems.map(function (item) { return '<li>✕ ' + esc(item) + '</li>'; }).join('') +
                '</ul></article>' +
                '<article class="tcb-facility-before-after__card tcb-facility-before-after__card--after"><h3>After</h3><ul>' +
                  afterItems.map(function (item) { return '<li>✓ ' + esc(item) + '</li>'; }).join('') +
                '</ul></article>' +
              '</div>' +
              '<ul class="tcb-facility-zone-details">' +
                '<li><strong>Recommended machine:</strong> ' + esc(z.machine) + '</li>' +
                '<li><strong>Essential supplies:</strong> ' + esc(z.supplies) + '</li>' +
                '<li><strong>Chemicals:</strong> ' + esc(z.chemicals) + '</li>' +
                '<li><strong>Maintenance parts:</strong> ' + esc(z.parts) + '</li>' +
                '<li><strong>Cleaning frequency:</strong> ' + esc(z.frequency) + '</li>' +
              '</ul>' +
            '</div>' +
            '<div class="tcb-facility-zone-panel__media">' +
              (zoneImageUrl ? '<img src="' + esc(zoneImageUrl) + '" alt="' + esc(z.label) + ' cleaning setup" loading="lazy" decoding="async" width="640" height="420" onerror="this.hidden=true;this.nextElementSibling.hidden=false">' : '') +
              '<span class="tcb-packages-hero__placeholder tcb-facility-zone-panel__placeholder"' + (zoneImageUrl ? ' hidden' : '') + ' aria-hidden="true"></span>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
    shell.innerHTML = '<div class="tcb-packages-tabs__nav" role="tablist">' + tabs + '</div><div class="tcb-packages-tabs__panels">' + panels + '</div>';
    shell.querySelectorAll('[data-tcb-zone]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tcb-zone');
        shell.querySelectorAll('[data-tcb-zone]').forEach(function (el) { el.classList.toggle('is-active', el === btn); });
        shell.querySelectorAll('[data-tcb-zone-panel]').forEach(function (panel) {
          var match = panel.getAttribute('data-tcb-zone-panel') === id;
          panel.classList.toggle('is-active', match);
          panel.hidden = !match;
        });
      });
    });
  }

  function renderFaq(root, facility, pageData) {
    var host = root.querySelector('[data-tcb-facility-faq]');
    if (!host) return;
    var faqs = (pageData && pageData.faq && pageData.faq.length) ? pageData.faq
      : (facility.faq && facility.faq.length) ? facility.faq
      : FAQ_DEFAULT.map(function (item, i) {
          if (i === 0) return { q: 'What is included in a ' + (facility.short_title || 'facility').toLowerCase() + ' cleaning package?', a: item.a };
          return { q: item.q, a: item.a };
        });
    host.innerHTML = faqs.map(function (f) {
      return '<details class="tcb-packages-faq__item"><summary>' + esc(f.q) + '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></summary><div class="tcb-packages-faq__answer rte"><p>' + esc(f.a) + '</p></div></details>';
    }).join('');
    injectFaqSchema(root, faqs);
  }

  function renderHeroChecks(root, facility, pageData) {
    var list = root.querySelector('[data-tcb-facility-checks]');
    if (!list) return;
    var checks = (pageData && pageData.hero_checks && pageData.hero_checks.length)
      ? pageData.hero_checks
      : (facility.hero_checks && facility.hero_checks.length)
        ? facility.hero_checks
        : null;
    if (!checks) return;
    list.innerHTML = checks.map(function (item) {
      return '<li>' + esc(item) + '</li>';
    }).join('');
  }

  function applyMasterCopy(root, pageData, facility) {
    if (!pageData && !facility) return;
    var f = facility || {};
    var shortTitle = f.short_title || 'Facility';
    var primaryCta = (pageData && pageData.primary_cta) || f.primary_cta || ('Find My ' + shortTitle + ' Package');
    var map = [
      ['[data-tcb-facility-kicker]', (pageData && pageData.kicker) || f.kicker],
      ['[data-tcb-facility-heading]', (pageData && (pageData.hero_heading || pageData.page_title)) || f.hero_heading],
      ['[data-tcb-facility-tagline]', (pageData && pageData.hero_tagline) || f.hero_tagline],
      ['[data-tcb-facility-primary-cta]', primaryCta],
      ['[data-tcb-facility-finder-heading]', (pageData && pageData.finder_heading) || f.finder_heading || ('Find the Right ' + shortTitle + ' Cleaning Package')],
      ['[data-tcb-facility-pain-heading]', 'Common ' + shortTitle + ' Cleaning Challenges We Solve'],
      ['[data-tcb-facility-grid-heading]', 'Choose Your ' + shortTitle + ' Cleaning Package'],
      ['[data-tcb-facility-compare-heading]', 'Compare ' + shortTitle + ' Cleaning Packages'],
      ['[data-tcb-facility-faq-heading]', shortTitle + ' Cleaning Package FAQs'],
      ['[data-tcb-facility-testimonials-heading]', 'What ' + shortTitle + 's Are Saying'],
      ['[data-tcb-facility-final-heading]', (pageData && (pageData.final_cta_heading || pageData.final_cta)) || f.final_cta],
    ];
    map.forEach(function (pair) {
      var el = root.querySelector(pair[0]);
      if (el && pair[1]) el.textContent = pair[1];
    });
    var intro = root.querySelector('[data-tcb-facility-intro]');
    var introHtml = (pageData && pageData.hero_intro) || f.hero_intro;
    if (intro) {
      if (introHtml) {
        intro.innerHTML = introHtml;
        intro.hidden = false;
      } else {
        intro.innerHTML = '';
        intro.hidden = true;
      }
    }
    var finderLead = root.querySelector('[data-tcb-facility-finder-lead]');
    var finderSubheading = (pageData && pageData.finder_subheading) || f.finder_subheading;
    if (finderLead) {
      if (finderSubheading) {
        finderLead.textContent = finderSubheading;
        finderLead.hidden = false;
      } else {
        finderLead.hidden = true;
      }
    }
    var finderSubmit = root.querySelector('[data-tcb-facility-finder-submit]');
    var finderButton = (pageData && pageData.finder_button) || f.finder_button;
    if (finderSubmit && finderButton) finderSubmit.textContent = finderButton;
    var videoCaption = root.querySelector('[data-tcb-facility-video-caption]');
    var caption = (pageData && pageData.video_caption) || f.video_caption;
    if (videoCaption && caption) videoCaption.textContent = caption;
    var finalBody = root.querySelector('[data-tcb-facility-final-body]');
    if (finalBody && ((pageData && pageData.final_cta_body) || f.final_cta_body)) {
      finalBody.textContent = (pageData && pageData.final_cta_body) || f.final_cta_body;
    }
    renderHeroChecks(root, f, pageData);
  }

  function applyCopy(root, facility) {
    applyMasterCopy(root, null, facility);
  }

  function initFinder(root, packages, master, presets) {
    var form = root.querySelector('[data-tcb-facility-finder]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var budget = (form.querySelector('[name="budget"]') || {}).value || '';
      var tierMap = { Starter: 'starter', 'Mid-range': 'growth', Professional: 'professional', 'Full facility': 'full-facility' };
      renderGrid(root, packages, tierMap[budget] || null, master, presets);
      var grid = document.getElementById('tcb-facility-packages-grid');
      if (grid) grid.scrollIntoView({ behavior: 'smooth' });
    });
  }

  function initSection(section) {
    var facilityId = section.getAttribute('data-facility-id');
    var catalogUrl = section.getAttribute('data-catalog-url');
    var masterUrl = section.getAttribute('data-master-url');
    var presetsUrl = section.getAttribute('data-cart-presets-url');
    var pageHandle = section.getAttribute('data-page-handle');
    if (!facilityId || !catalogUrl) return;

    initSticky(section);

    Promise.all([
      fetch(catalogUrl).then(function (r) { return r.json(); }),
      masterUrl ? fetch(masterUrl).then(function (r) { return r.json(); }).catch(function () { return null; }) : Promise.resolve(null),
      presetsUrl ? fetch(presetsUrl).then(function (r) { return r.json(); }).catch(function () { return null; }) : Promise.resolve(null),
    ]).then(function (results) {
        var data = results[0];
        var master = results[1];
        var presets = results[2];
        var pageData = master && master.pages_by_handle ? master.pages_by_handle[pageHandle] : null;
        var facility = (data.facilities || []).find(function (f) { return f.id === facilityId; });
        if (!facility) return;
        var packages = landingPackages(facility, (data.sub_packages || []).filter(function (p) { return p.facility_id === facilityId; }));
        if (pageData && pageData.pain_points && pageData.pain_points.length) {
          facility = Object.assign({}, facility, {
            pain_points: pageData.pain_points.map(function (p) { return { title: p.title, text: p.body || p.text || '' }; }),
          });
        }
        if (pageData && pageData.hero_checks && pageData.hero_checks.length) {
          facility = Object.assign({}, facility, { hero_checks: pageData.hero_checks });
        }
        if (pageData && pageData.primary_cta) {
          facility = Object.assign({}, facility, { primary_cta: pageData.primary_cta });
        }
        if (pageData && pageData.cleaning_zones && pageData.cleaning_zones.length) {
          facility = Object.assign({}, facility, {
            zones: pageData.cleaning_zones.map(function (z, i) {
              return {
                id: z.id || String(z.label || 'zone').toLowerCase().replace(/[^a-z0-9]+/g, '-'),
                label: z.label,
                machine: z.machine,
                supplies: z.supplies,
                chemicals: z.chemicals,
                parts: z.parts,
                frequency: z.frequency,
              };
            }),
          });
        }
        applyMasterCopy(section, pageData, facility);
        applyHeroImage(section, pageData, presets, facility);
        applyFinalCtaImage(section, pageData, presets, facility);
        renderPain(section, facility);
        renderGrid(section, packages, null, master, presets);
        renderFeatured(section, facility, packages, master, presets);
        renderCompare(section, packages);
        renderZones(section, facility, pageHandle, section.getAttribute('data-hero-asset-sample'));
        renderFaq(section, facility, pageData);
        initFinder(section, packages, master, presets);
      })
      .catch(function () {
        var grid = section.querySelector('[data-tcb-facility-grid]');
        if (grid) grid.innerHTML = '<p class="tcb-packages-loading">Unable to load packages.</p>';
      });

    var video = section.querySelector('[data-tcb-facility-video-trigger]');
    if (video) {
      video.addEventListener('click', function () {
        var finder = document.getElementById('tcb-facility-finder');
        if (finder) finder.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tcb-facility-packages]').forEach(initSection);
  });
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-tcb-facility-packages]');
    if (section) initSection(section);
  });
})();
